import React from "react";

const InTime = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M7.563 34c-.415 0-.812-.169-1.105-.469A1.62 1.62 0 016 32.4V3.6c0-.424.165-.831.458-1.131.293-.3.69-.469 1.104-.469h21.875c.415 0 .812.169 1.105.469.293.3.458.707.458 1.131v28.8c0 .424-.165.831-.458 1.131-.293.3-.69.469-1.105.469H7.563zm15.625-9.6L31 18l-7.813-6.4v4.8h-9.375v3.2h9.376v4.8z"
            fill={fill}
        />
    </svg>
);

export default InTime;
